import PropTypes from 'prop-types';
import RequiredInput from '../elements/required-input';

const LastNameInput = ({
  model = '.last_name', label = 'Last name', controlId = 'lastName', readOnly = false, errorLabel = 'user_last_name'
}) => (
  <RequiredInput
    controlId={controlId}
    errorLabel={errorLabel}
    label={label}
    model={model}
    placeholder="Last name"
    readOnly={readOnly}
  />
);

LastNameInput.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
};

export default LastNameInput;
